import React from "react";
import "../Styles/Footer.css";
// import footer1 from "../Assets/footer1.jpg";
import footer2 from "../Assets/news_small2.jpg";
import footer3 from "../Assets/news_small.jpg";
import logo from "../Assets/logo.png";
import { Link } from "react-router-dom";

const currentYear = new Date().getFullYear();
function Footer() {
  return (
    <>
      <div className="footer_container">
        <div className="scontainer">
          <div className="row">
            <div
              data-aos="fade-right"
              // data-aos-duration="1500"
              data-aos-mirror="true"
              data-aos-once="false"
              data-aos-easing="ease-in-out"
              className="col-xl-3 col-md-6 col-sm-12 footer_about"
            >
              <div className="footer_about_text">
                <h6 className="footer_title">About Us</h6>
                <p>
                  PyLoan is an independent informational website publishing
                  educational articles about loans, eligibility criteria,
                  documents, application steps and government-supported finance
                  schemes. We do not provide, approve or arrange loans.
                </p>
              </div>
              <div className="footer_social_icons">
                <div className="footer_icons_box">
                  <a href="https://www.facebook.com/">
                    <i class="fa-brands fa-facebook-f"></i>
                  </a>
                </div>

                <div className="footer_icons_box">
                  <a href="https://www.instagram.com/">
                    <i class="fa-brands fa-instagram"></i>
                  </a>
                </div>

                <div className="footer_icons_box">
                  <a href="https://www.twitter.com/">
                    <i class="fa-brands fa-twitter"></i>
                  </a>
                </div>

                <div className="footer_icons_box">
                  <a href="https://www.linkedin.com/">
                    <i class="fa-brands fa-linkedin-in"></i>
                  </a>
                </div>
              </div>
            </div>
            <div
              data-aos="fade-down"
              data-aos-duration="1500"
              data-aos-mirror="true"
              data-aos-once="false"
              data-aos-easing="ease-in-out"
              className="col-xl-3 col-md-6 col-sm-12"
            >
              <h1 className="footer_title">News Feeds</h1>
              <div className="footer_news_container">
                {/* <div className="footer_news_content">
                  <div className="footer_img">
                    <img src={footer1} alt="footer Img1" />
                  </div>
                  <div className="footer_news_text">
                    <p className="footer_news_time">
                      <i class="fa-solid fa-calendar-days"></i> 24th November
                      2023
                    </p>
                    <h4 className="footer_news_desc">
                      The Most Successful Engineering Contractor
                    </h4>
                  </div>
                </div> */}
                <div className="footer_news_content">
                  <div className="footer_img">
                    <img src={footer2} alt="footer Img1" />
                  </div>
                  <div className="footer_news_text">
                    <p className="footer_news_time">
                      <i class="fa-solid fa-calendar-days"></i> 24th November
                      2022
                    </p>
                    <h4 className="footer_news_desc">
                      How to read loan eligibility information
                    </h4>
                  </div>
                </div>
                <div className="footer_news_content">
                  <div className="footer_img">
                    <img src={footer3} alt="footer Img1" />
                  </div>
                  <div className="footer_news_text">
                    <p className="footer_news_time">
                      <i class="fa-solid fa-calendar-days"></i> 24th November
                      2023
                    </p>
                    <h4 className="footer_news_desc">
                      Government scheme rules can change
                    </h4>
                  </div>
                </div>
              </div>
            </div>
            <div
              data-aos="fade-up"
              // data-aos-duration="1500"
              data-aos-mirror="true"
              data-aos-once="false"
              data-aos-easing="ease-in-out"
              className="col-xl-3 col-md-6 col-sm-12"
            >
              <h1 className="footer_title">Explore</h1>
              <div className="footer_newsletter_container">
                <div className="footer_newsletter_text">
                  <p>
                    Read our loan guides and verify current details with the
                    relevant official source before taking action.
                  </p>
                  <Link className="btn footer_news_letter" to="/service">
                    Browse Loan Guides <i className="fa-solid fa-arrow-right" title="Browse"></i>
                  </Link>
                </div>
              </div>
            </div>
            <div
              data-aos="fade-left"
              // data-aos-duration="1500"
              data-aos-mirror="true"
              data-aos-once="false"
              data-aos-easing="ease-in-out"
              className="col-xl-3 col-md-6 col-sm-12"
            >
              <h1 className="footer_title">Get In Touch</h1>
              <div className="footer_news_content">
                <div className="footer_call_box">
                  <i class="fa-solid fa-phone"></i>
                </div>
                <div className="footer_news_text">
                  <p className="footer_news_time">
                    <i class="fa-solid fa-phone"></i>&nbsp; Phone Number
                  </p>
                <h4 className="footer_news_desc">
                  <a href="tel:9873691307">+91 9873691307</a>
                </h4>
                </div>
              </div>
              <div className="footer_news_content">
                <div className="footer_call_box">
                  <i class="fa-solid fa-envelope"></i>
                </div>
                <div className="footer_news_text">
                  <p className="footer_news_time">
                    <i class="fa-solid fa-envelope"></i>&nbsp; Email Us
                  </p>
                  <h4 className="footer_news_desc">
                    <a href="mailto:Mudraloanhelp0@gmail.com">Mudraloanhelp0@gmail.com</a>
                  </h4>
                </div>
              </div>
              <div className="footer_news_content">
                <div className="footer_call_box">
                  <i class="fa-solid fa-location-arrow"></i>
                </div>
                <div className="footer_news_text">
                  <p className="footer_news_time">
                    <i class="fa-solid fa-location-arrow"></i>&nbsp; Location
                  </p>
                  <h4 className="footer_news_desc">Mahipalpur, New Delhi</h4>
                </div>
              </div>
              <div className="footer_news_content">
                <div className="footer_call_box">
                  <i class="fa-brands fa-whatsapp"></i>
                </div>
                <div className="footer_news_text">
                  <p className="footer_news_time">
                    <i class="fa-solid fa-circle-info"></i>&nbsp; Information
                  </p>
                <h4 className="footer_news_desc">Questions? Contact us</h4>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="row">
        <div className="col-md-12 pd_0">
          <div className="footer_bottom">
            <div style={{ display: "flex" }}>
              <p>© Copyright By Dustrix - {currentYear}</p>
              <Link to="/terms_of_use">
                <p
                  style={{
                    marginLeft: 23,
                    fontWeight: "bold",
                    fontSize: 19,
                    textDecoration: "underline",
                  }}
                >
                  Terms of Use
                </p>
              </Link>
              <Link to="/privacy_policy">
                <p
                  style={{
                    marginLeft: 23,
                    fontWeight: "bold",
                    fontSize: 19,
                    textDecoration: "underline",
                  }}
                >
                  Privacy Policy
                </p>
              </Link>
            </div>
            <img src={logo} alt="Footer Logo" />
          </div>
        </div>
      </div>
    </>
  );
}

export default Footer;
